/** Runtime `(hidden)` labels from live Status. Never persist this suffix. */
export const HIDDEN_NAME_SUFFIX = ' (hidden)';

export function isHiddenStatus(status: number | string | null | undefined): boolean {
  if (status === null || status === undefined || status === '') {
    return false;
  }
  return Number(status) !== 1;
}

/** Strip leftover `(hidden)` from polluted DB / payload names. */
export function stripHiddenNameSuffix(name: string | null | undefined): string {
  if (!name) {
    return name ?? '';
  }
  const trimmed = name.trimEnd();
  const lower = trimmed.toLowerCase();
  if (lower.endsWith(HIDDEN_NAME_SUFFIX.toLowerCase())) {
    return trimmed.slice(0, -HIDDEN_NAME_SUFFIX.length).trimEnd();
  }
  // Tolerate missing leading space from older pollution.
  if (lower.endsWith('(hidden)')) {
    return trimmed.slice(0, -'(hidden)'.length).trimEnd();
  }
  return name;
}

/** Canonical name + optional `(hidden)` from status (Status != 1). */
export function visibilityDisplayName(
  name: string | null | undefined,
  status?: number | string | null
): string {
  const clean = stripHiddenNameSuffix(name);
  if (!clean) {
    return clean;
  }
  return isHiddenStatus(status) ? `${clean}${HIDDEN_NAME_SUFFIX}` : clean;
}
